interface TinKernLogoProps {
  /** Size token. sm = 32px, md = 48px, lg = 64px. Override via className for arbitrary sizes. */
  size?: 'sm' | 'md' | 'lg'
  /** "mono" → silver-on-black gear; "color" → full-color master. */
  variant?: 'mono' | 'color'
  /** Override the resolved image path. Defaults to /media/brand/tinkern-logo[-color].(jpg|png). */
  src?: string
  /** Extra classes — appended to the size + base classes. */
  className?: string
  /** Alt text. Defaults to "TinKern Labs". */
  alt?: string
}

const SIZE = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
}

const DEFAULT_SRC = {
  mono: '/media/brand/tinkern-logo.jpg',
  color: '/media/brand/tinkern-logo-color.png',
}

export default function TinKernLogo({
  size = 'md',
  variant = 'mono',
  src,
  className = '',
  alt = 'TinKern Labs',
}: TinKernLogoProps) {
  const resolved = src ?? DEFAULT_SRC[variant]
  return (
    <img
      src={resolved}
      alt={alt}
      loading="eager"
      decoding="async"
      className={`${SIZE[size]} rounded-full object-cover bg-black ${className}`}
    />
  )
}
